import React from 'react';
import { FaCheck, FaArrowRight } from 'react-icons/fa';
import Link from 'next/link';
import styles from './PricingSection.module.css';

const PricingCard = ({
    title,
    subtitle,
    description,
    accentClass,
    badgeText,
    featuresHeader,
    featuresHeaderIcon: Icon,
    features = [],
    buttonText,
    buttonLink = "/credits",
    buttonClass,
    children,
    featuresIconColor = "#10b981",
    checkIconClass = ""
}) => {
    return (
        <div className={`${styles.pricingCard} ${accentClass}`}>
            {badgeText && <div className={styles.popularBadge}>{badgeText}</div>}

            <div className={styles.cardHeader}>
                <span className={styles.cardSubtitle}>{subtitle}</span>
                <h3 className={styles.cardTitle}>{title}</h3>
                <p className={styles.cardDescription}>{description}</p>
            </div>

            {featuresHeader && (
                <div className={styles.featuresListHeader}>
                    {Icon && <Icon style={{ color: featuresIconColor }} />}
                    {featuresHeader}
                </div>
            )}

            {children ? (
                children
            ) : (
                <ul className={styles.featuresList}>
                    {features.map((feature, index) => (
                        <li key={index} className={styles.featureItem}>
                            <span className={`${styles.checkIcon} ${checkIconClass}`}>
                                <FaCheck />
                            </span>
                            {feature}
                        </li>
                    ))}
                </ul>
            )}

            <div className={styles.cardFooter}>
                <Link href={buttonLink}>
                    <button className={`${styles.btnAction} ${buttonClass}`}>
                        {buttonText} <FaArrowRight />
                    </button>
                </Link>
            </div>
        </div>
    );
};

export default PricingCard;
